<template>
  <!-- 客户列表 -->
  <div class="memList">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['客户管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
        <el-button type="primary" icon="el-icon-download" @click="exportData"
          >导出数据</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="selectedList.length == 0"
          @click="handleDel"
          >批量删除</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-s-check"
          :disabled="selectedList.length == 0"
          @click="auditCheck"
          >批量审核</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <!-- 洛奥的客户状态和等级没有用，去掉了 -->
        <!-- <el-````````select````````
            v-model="search.grade"
            placeholder="客户等级"
            style="width: 100px; margin-right: 5px"
          >
            <el-option
              label="全部"
              value=""
            ></el-option>
            <el-option
              v-for="(item, index) in 10"
              :key="index"
              :label="'等级'+(item-1)"
              :value="item-1"
            ></el-option>
          </el-select> -->
        <!-- <el-date-picker
          v-model="search.Time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          style="margin-right: 5px"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker> -->
        <label class="label">区域：</label>
        <el-cascader
          v-model="search.addressData"
          placeholder="选择地址(可搜索)"
          :options="$store.state.citys"
          clearable
          :props="{ value: 'label', label: 'label', checkStrictly: true }"
          style="width: 150px; margin-right: 10px"
          filterable
          ref="addressSel"
        >
        </el-cascader>
        <label class="label">状态：</label>
        <el-select
          v-model="search.status"
          placeholder="客户状态"
          style="width: 100px; margin-right: 10px"
        >
          <el-option
            v-for="(item, index) in itemList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span class="labeljs">检索：</span>
        <el-input
          v-model="search.name"
          style="width: 150px; margin-right: 5px"
          placeholder="客户编号/名称"
          clearable
        ></el-input>
        <el-input
          v-model="search.telphone"
          style="width: 150px; margin-right: 5px"
          placeholder="客户手机号"
          clearable
        ></el-input>
        <el-input
          v-model="search.salesMan"
          style="width: 150px; margin-right: 5px"
          placeholder="业务员编号/名称"
          clearable
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="seachData"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column
        prop="username"
        align="center"
        show-overflow-tooltip
        label="用户编号"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="telphone"
        label="手机号"
        align="center"
        show-overflow-tooltip
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="businesscode"
        label="单位编号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="businessname"
        label="单位名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="khType"
        label="客户类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="province"
        label="省"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="city"
        label="市"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="shortname"
        label="价格等级"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="point"
        label="积分"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Balance"
        label="余额"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="add_time"
        label="创建日期"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <!-- <el-button
            type="primary"
            plain
            style="padding: 2px 3px"
            @click="seeInfo(scope.row)"
            >详情</el-button
          > -->
          <!-- 洛奥添加了用户列表，这些操作在用户列表中 -->
          <!-- <el-button
            type="warning"
            plain
            style="padding: 2px 3px"
            @click="resetPassword(scope.row)"
            >重置密码</el-button
          >
          <el-button
            type="danger"
            plain
            style="padding: 2px 3px"
            v-if="scope.row.status == 2"
            @click="changeStatus(scope.row, 1)"
            >禁用</el-button
          >
          <el-button
            type="success"
            plain
            style="padding: 2px 3px"
            v-if="scope.row.status == 1"
            @click="changeStatus(scope.row, 2)"
            >(审核)启用</el-button
          >
          <el-button
            type="primary"
            plain
            style="padding: 2px 3px"
            @click="bindUser(scope.row)"
            v-if="
              !scope.row.FatherUserId ||
                scope.row.FatherUserId == scope.row.userid
            "
            >绑定账号</el-button
          > -->
          <!-- 价格等级现在没有使用 -->
          <!-- <el-button
            type="primary"
            plain
            style="padding: 2px 3px"
            @click="priceLevel(scope.row)"
            >价格等级</el-button
          > -->
          <!-- 现在没有使用 -->
          <!-- <el-button
              type="primary"
              plain
              style="padding: 2px 3px"
              @click="delUserWx(scope.row)"
              v-if="scope.row.openId"
              >解绑微信</el-button
            > -->
          <!-- <el-button type="primary" plain style="padding:2px 3px;" @click="setCoupon(scope.row)">修改优惠券</el-button> -->
          <!-- <el-button
            type="primary"
            plain
            style="padding: 2px 3px; margin-left: 0"
            @click="handleBindPayType(scope)"
            >支付方式</el-button
          > -->
          <el-button
            type="success"
            plain
            style="padding: 2px 3px"
            @click="handleTopUp(scope)"
            >充值</el-button
          >
          <!-- <el-button
            type="success"
            plain
            style="padding: 2px 3px"
            @click="handleViewHistory(scope)"
            >充值流水</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 添加管理员 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">添加管理员</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="80px"
            :rules="formRule"
            ref="addForm"
          >
            <el-form-item label="用户名" prop="user">
              <el-input v-model="addForm.user" clearable></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="pass">
              <el-input v-model="addForm.pass" clearable></el-input>
            </el-form-item>
            <el-form-item label="所属机构" prop="organ">
              <el-select
                v-model="addForm.organ"
                placeholder="请选择"
                clearable
                style="width: 100%"
              >
                <el-option label="开启" value="开启"></el-option>
                <el-option label="关闭" value="关闭"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="管理角色" prop="role">
              <el-select
                v-model="addForm.role"
                placeholder="请选择"
                clearable
                style="width: 100%"
              >
                <el-option label="开启" value="开启"></el-option>
                <el-option label="关闭" value="关闭"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="真实姓名" prop="name">
              <el-input v-model="addForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="tel">
              <el-input v-model="addForm.tel" clearable></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
              <el-select
                v-model="addForm.sex"
                placeholder="请选择"
                clearable
                style="width: 100%"
              >
                <el-option label="开启" value="开启"></el-option>
                <el-option label="关闭" value="关闭"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input v-model="addForm.address" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
    <!-- 优惠券发放dialog -->
    <el-dialog
      title="优惠券发放"
      :visible.sync="couponDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <search-bar>
        <template>
          <el-input
            v-model="searchForm2.name"
            style="width: 200px; margin-right: 5px"
          ></el-input>
          <el-button type="primary" icon="el-icon-search">搜索</el-button>
          <el-button
            type="primary"
            icon="el-icon-check"
            :disabled="selectedList2.length == 0"
            >确定</el-button
          >
        </template>
      </search-bar>
      <el-table
        :data="couponList"
        stripe
        border
        height="300px"
        tooltip-effect="dark"
        @selection-change="selection2Change"
        style="width: 100%"
      >
        <el-table-column
          type="selection"
          align="center"
          fixed="left"
          width="55"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          align="center"
          show-overflow-tooltip
          label="名称"
        >
        </el-table-column>
        <el-table-column
          prop="repertory"
          label="库存"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="startTime"
          label="开始时间"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="endTime"
          label="结束时间"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="deviceType"
          label="设备类型"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="range"
          label="范围"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="modeRule"
          label="规则类型"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="goodsRange"
          label="商品范围"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="money"
          label="条件(金额)"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="num"
          label="条件(件数)"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="sale"
          label="优惠金额"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="discount"
          label="折扣"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <pagination
        :allPage="allPage2"
        :pageSize="pageSize2"
        :currIndex="currPage2"
        @hanSiChange="hanSiChange2"
        @hanCurrChange="hanCurrChange2"
      ></pagination>
    </el-dialog>
    <!-- 修改优惠券弹窗 -->
    <el-drawer
      :visible.sync="isCoupon"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">修改优惠券</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="couponForm"
            label-position="rigth"
            label-width="100px"
            :rules="couponRule"
            ref="couponForm"
          >
            <el-form-item label="优惠券金额" prop="coupon">
              <el-input v-model="couponForm.coupon"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="couponSubmit">确定</el-button>
        <el-button type="info" @click="couponClear">取消</el-button>
      </div>
    </el-drawer>

    <!-- 价格等级 -->
    <tableDialog
      v-if="isPriceLevel"
      :title="'价格等级'"
      :searchValue="priceLevelSearch.name"
      :tableData="priceLevleList"
      :tableHead="priceLevleHead"
      :currPage.sync="priceLevlePage"
      :pageSize.sync="pageSizeData"
      :allPage="priceLevleAll"
      @search="getPriceLevel"
      @rowClick="setPriceLevle"
      @hanCurrChange="setPriceLevelPage"
      @hanSizesChange="hanSizesChange"
      @close="isPriceLevel = false"
    ></tableDialog>

    <!-- 支付方式绑定 -->
    <el-dialog
      title="支付方式绑定"
      :visible.sync="bindPayTypeDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="500px"
    >
      <el-form label-width="120px">
        <el-form-item label="支付方式：">
          <el-checkbox-group v-model="checkedPayType">
            <el-checkbox
              v-for="item in payTypeList"
              :label="item.PayId"
              :key="item.PayId"
              >{{ item.PayType }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="bindPayType">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>该界面显示的为从ERP同步过来的基础客户数据</p>
        <p>
          详情：可设置客户性别、联系电话、会员生日、客户状态、区域等信息，<span
            style="font-weight: bold"
            >灰色输入框</span
          >代表不可修改
        </p>
        <p>
          绑定账号：同一单位账号可设置绑定，在APP和PC商城中可快捷切换绑定账号
        </p>
        <p>
          绑定支付方式：默认客户绑定所有支付方式(一个都未绑定也是默认所有)，可为客户绑定某一个或者多个
        </p>
        <!-- <p>价格等级：可调整用户的价格等级，商品价格等级设置：<span style="font-weight: bold;">商城管理->商品列表</span></p> -->
      </div>
    </el-dialog>

    <!-- 用户充值 -->
    <el-dialog
      title="用户充值"
      :visible.sync="topUpDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="600px"
    >
      <div>
        <el-form label-width="100px">
          <el-form-item label="用户：">
            <span>{{ selectedMem.name }}</span>
          </el-form-item>
          <el-form-item label="公司名：">
            <span>{{ selectedMem.businessname }}</span>
          </el-form-item>
          <el-form-item label="充值金额：">
            <el-input-number
              v-model="topUpMoney"
              style="width: 200px"
              :controls="false"
            ></el-input-number>
            <span class="form-item-tip">*正数为增加，负数为减少</span>
          </el-form-item>
          <el-form-item label="备注：" required>
            <el-input v-model="topRemark" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button type="warning" @click="submitTopMoney">设置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- 用户充值流水 -->
    <el-dialog
      title="充值流水"
      :visible.sync="topUpHisDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="800px"
    >
      <search-bar>
        <template>
          <el-date-picker
            v-model="searchForm3.start"
            style="width: 200px; margin-right: 5px"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            clearable
            placeholder="开始日期"
          >
          </el-date-picker>
          <el-date-picker
            v-model="searchForm3.end"
            style="width: 200px; margin-right: 5px"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            clearable
            placeholder="结束日期"
          >
          </el-date-picker>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getUserHistory"
            >搜索</el-button
          >
        </template>
      </search-bar>
      <el-table
        :data="historyList"
        stripe
        border
        height="400"
        tooltip-effect="dark"
      >
        <el-table-column prop="orderNo" align="center" label="订单号">
        </el-table-column>
        <el-table-column
          prop="amount"
          align="center"
          label="充值金额"
          width="100"
        >
        </el-table-column>
        <el-table-column prop="addTime" align="center" label="日期" width="150">
        </el-table-column>
        <el-table-column
          prop="remark"
          show-overflow-tooltip
          align="center"
          label="备注"
        >
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :allPage="allPage3"
        :pageSize="pageSize3"
        :currIndex="currPage3"
        @hanSiChange="hanSiChange3"
        @hanCurrChange="hanCurrChange3"
      ></pagination>
    </el-dialog>

    <!-- 业务员列表 -->
    <el-dialog
      title="请选择"
      :visible.sync="saleManDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="800px"
    >
      <search-bar>
        <template>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入名称检索"
            v-model="saleManName"
            @keydown.native.enter="('search')"
          >
          </el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getSalemanList('search')"
            >搜索</el-button
          >
        </template>
      </search-bar>
      <el-table
        :data="salesmenList"
        stripe
        border
        tooltip-effect="dark"
        height="300px"
      >
        <el-table-column label="序号" type="index" align="center" width="50">
        </el-table-column>
        <el-table-column
          v-if="searchType == 'saleMan'"
          label="业务员"
          prop="Name"
          align="center"
          width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          v-else-if="searchType == 'invoice'"
          label="开票员"
          prop="Name"
          align="center"
          width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="手机号"
          prop="TelPhone"
          align="center"
          width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="primary"
              style="padding: 2px 3px"
              plain
              @click="handleSalemanItem(scope)"
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :allPage="allPage1"
        :pageSize="pageSize1"
        :currIndex="pageIndex1"
        @hanSiChange="hanSiChange1"
        @hanCurrChange="hanCurrChange1"
      ></pagination>
    </el-dialog>
  </div>
</template>

<script>
//混入
import { formatStatus } from "@/mixins/filters/formatStatus.js";
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "memList",
  mixins: [formatStatus],
  data() {
    return {
      /**用户信息 */
      entId: "",

      adminId: this.$store.state.userInfo.adminId,
      organId: this.$store.state.userInfo.organId,
      /**表格数据 */
      // 用户名 操作 状态 性别 姓名 手机 单位编号 单位名称 客户级别 客户类型 机构 创建日期
      tableData: [],
      itemList: [
        {
          value: "99",
          label: "全部",
        },
        {
          value: "1",
          label: "未审核",
        },
        {
          value: "2",
          label: "已审核",
        },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**新增管理员drawer */
      addDrawer: false,
      /**表单数据 */
      addForm: {
        user: "",
        pass: "",
        organ: "",
        role: "",
        name: "",
        tel: "",
        sex: "",
        address: "",
      },
      /**表单验证 */
      formRule: {
        name: [{ required: true, message: "请输入配置名称", trigger: "blur" }],
      },
      /**搜索表单 */
      search: {
        grade: "",
        status: "2",
        name: "",
        salesMan: "",
        telphone: "", //客户手机号
        Time: "", //时间范围
        startTime: "",
        endTime: "",
        addressData: [],
      },
      /**select选中项 */
      selectedList: [],

      /**优惠券发放dialog */
      couponDialog: false,
      /**优惠券数据 */
      //选择	序号	名称	库存	开始时间	结束时间	设备类型	范围
      //规则类型	商品范围	条件(金额)	条件(件数)	优惠金额	折扣
      couponList: [
        {
          name: "名称",
          repertory: "库存",
          startTime: "开始时间",
          endTime: "结束时间",
          deviceType: "设备类型",
          range: "范围",
          modeRule: "规则类型",
          goodsRange: "商品范围",
          money: "条件(金额)",
          num: "条件(件数)",
          sale: "优惠金额",
          discount: "折扣",
        },
      ],
      /**优惠券搜索表单 */
      searchForm2: {
        name: "",
      },
      /**选中优惠券list */
      selectedList2: [],
      idList: [],
      /**优惠券分页数据 */
      currPage2: 1,
      pageSize2: 0,
      allPage2: 0,
      // 修改优惠券金额相关
      isCoupon: false,
      couponForm: {
        id: "",
        coupon: "",
      },
      couponRule: {
        coupon: [mustFill],
      },
      // 价格等级相关
      priceLevelUserId: "", // 价格等级绑定的用户编号
      isPriceLevel: false,
      priceLevleList: [],
      priceLevleHead: {},
      priceLevelSearch: {
        name: "",
      },
      priceLevlePage: 1,
      pageSizeData: 10,
      priceLevleAll: 0,

      /**绑定支付方式 */
      bindPayTypeDialog: false,
      selectedUser: null, //选中的用户数据
      checkedPayType: [], // 选中的支付方式
      payTypeList: [], //支付方式列表

      /**使用说明 */
      explain: false,

      /**用户充值 */
      selectedMem: { name: "", businessname: "" }, //选中的会员
      topUpDialog: false, //dialog
      topUpMoney: 0, //设置金额
      topRemark: "", //充值备注

      /**充值流水 */
      searchForm3: {
        start: "", //开始日期
        end: "",
      },
      topUpHisDialog: false,
      currPage3: 1, // 分页
      pageSize3: 20,
      allPage3: 0,
      historyList: [], //历史列表

      /**业务员/开票员列表 */
      selectedItem: null, //选中项
      searchType: "saleMan", //搜索类型 saleMan开票员  invoice业务员
      saleManDialog: false,
      saleManName: "", //查询关键词
      salesmenList: [],
      pageIndex1: 1,
      pageSize1: 20,
      allPage1: 0,
    };
  },
  components: {},
  mounted() {
    this.entId = localStorage.getItem("entId");
    this.getTableData();
    this.search.status = this.itemList[2].value;
    this.getPayType();
  },
  methods: {
    /**绑定支付方式相关 */
    /**表格点击绑定按钮 */
    handleBindPayType({ row }) {
      this.checkedPayType = row.PayType.split(",");
      console.log(this.checkedPayType, "232323232");
      this.selectedUser = row;
      this.bindPayTypeDialog = true;
    },

    /**获取支付方式 */
    getPayType() {
      this.$request({
        url: "Base/GetEntPayTypeList",
        method: "post",
        data: {
          entId: this.entId,
        },
      })
        .then((res) => {
          if (res.success) {
            this.payTypeList = res.list.map((item) => {
              return {
                PayType: item.PayType,
                PayId: item.PayId + "", //转换为字符串
              };
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**确定绑定 */
    bindPayType() {
      this.$request({
        url: "Management/MemberAdmin/EditUserPayType",
        method: "post",
        data: {
          userId: this.selectedUser.userid,
          payType: this.checkedPayType.join(),
        },
      })
        .then((res) => {
          if (res.success) {
            // 直接给表格赋值，不直接更新数据了
            this.selectedUser.PayType = this.checkedPayType.join();
            this.bindPayTypeDialog = false;
          }
          this.$message({
            message: res.message,
            type: res.success ? "success" : "error",
          });
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    updata() {
      this.getTableData();
    },
    seachData() {
      this.getTableData(1);
    },
    // 获取表格信息
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      if (this.search.Time == null) {
        this.search.startTime = "";
        this.search.endTime = "";
      } else {
        this.search.startTime = this.search.Time[0];
        this.search.endTime = this.search.Time[1];
      }

      let data = {
        type: "GetUserInfo",
        status: this.search.status,
        strWhere: this.search.name,
        salesMan: this.search.salesMan,
        telphone: this.search.telphone,
        // startTime: this.search.startTime,
        // endTime: this.search.endTime,
        PageIndex: this.currPage,
        Porowince: this.search.addressData[0],
        County: this.search.addressData[2],
        City: this.search.addressData[1],
        PageSize: this.pageSize,
        khId: this.search.grade, //客户等级
      };
      let proc = "Proc_Admin_MembersQuery"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "members/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          this.tableData = [];
          this.allPage = 0;
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 批量审核
    auditCheck() {
      let idList = [];
      this.selectedList.forEach((i) => {
        idList.push(i.userid);
      });
      idList = idList.join();
      this.$confirm("确定审核吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(() => {
          this.bulkEditing(idList, 2);
        })
        .catch(() => {});
    },
    /**点击批量删除 */
    handleDel() {
      let idList = [];
      this.selectedList.forEach((i) => {
        idList.push(i.userid);
      });
      idList = idList.join();
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          this.bulkEditing(idList, 0);
        })
        .catch(() => {});
    },
    uphold() {
      this.$router.push("registCertificate");
    },
    /**批量删除，修改信息*/
    bulkEditing(s, uptype) {
      let data = {
        type: "PC_SetUserInfo",
        strWhere: s,
        uptype: uptype,
      };
      let proc = "Proc_Admin_MembersQuery"; // 存储过程名
      let type = "ReturnNumber";
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.$message({
              message: res.message,
              type: "success",
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**客户 selection change触发事件 */
    selectionChange(section) {
      this.selectedList = section;
    },
    /**编辑表格数据 */
    handleEdit(row) {
      for (const key in this.addForm) {
        this.addForm[key] = row[key];
      }
      this.addDrawer = true;
    },
    seeInfo(row) {
      let prams = encodeURIComponent(JSON.stringify({ id: row.userid }));
      let path = "memInfo";
      this.$router.push({
        path: path,
        query: {
          prams: prams,
        },
      });
    },

    // 确定重置密码吗
    resetPassword(row) {
      console.log(row);
      this.$confirm("确定重置密码吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(() => {
          let data = {
            userId: row.userid,
            userType: "Client",
          };
          this.$request({
            method: "post",
            url: "/Management/MemberAdmin/ResetUserPassword",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    /**修改客户状态 */
    changeStatus(row, status) {
      this.$confirm("确定操作此条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(() => {
          let data = {
            type: "AuditUser",
            userId: row.userid,
            status: status,
          };
          let proc = ""; // 存储过程名
          let type = "AuditUser";
          this.$requestSys({
            method: "post",
            url:
              "members/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    // 绑定客户账号
    bindUser(row) {
      let prams = null;
      if (row) {
        prams = encodeURIComponent(JSON.stringify({ id: row.userid }));
      } else {
        prams = row;
      }
      this.$router.push({
        path: "bindUser",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },
    // 绑定价格等级
    priceLevel(row) {
      this.priceLevelUserId = row.userid;
      this.getPriceLevel();
    },
    // 获取机构等级
    getPriceLevel(val, isRep) {
      this.priceLevelSearch.name = isRep ? val : this.priceLevelSearch.name;
      let data = {
        entId: window.localStorage.getItem("entId"),
        searchVal: this.priceLevelSearch.name,
        pageIndex: this.priceLevlePage,
        pageSize: this.pageSizeData,
      };
      this.$request({
        method: "post",
        url: "GoodsAdmin/GetPriceLevel",
        data: data,
      })
        .then((res) => {
          this.priceLevleList = [];
          this.priceLevleAll = 0;
          if (res.success) {
            this.priceLevleAll = res.toTal;
            this.priceLevleList = (res.list || []).map((item) => ({
              id: item.PriceCode, // 价格等级编号
              name: item.PriceName, // 价格等级名称
            }));
            this.priceLevleHead = { id: "价格等级编号", name: "价格等级名称" };
            this.isPriceLevel = true;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 设置价格等级列表页码
    setPriceLevelPage(val) {
      this.priceLevlePage = val;
      this.getPriceLevel();
    },
    // 设置价格等级列表页码
    hanSizesChange(val) {
      this.pageSizeData = val;
      this.getPriceLevel();
    },
    // 设置客户价格数据
    setPriceLevle(row) {
      let data = {
        userId: this.priceLevelUserId,
        businessId: this.priceLevelUserId,
        priceType: row.id,
      };
      this.$request({
        url: "MemberAdmin/EditClientPriceLeve",
        method: "post",
        data: data,
      }).then((res) => {
        if (res.success) {
          this.$message({
            message: "修改价格等级成功",
            type: "success",
          });
          this.handleRefresh();
          this.isPriceLevel = false;
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
    // 解绑微信
    delUserWx(row) {
      this.$confirm("确定要解绑微信吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(() => {
          let data = {
            userId: row.userid,
          };
          this.$request({
            url: "Users/DltUserWx",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "解绑成功",
                type: "success",
              });
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      this.$refs["addForm"].resetFields();
      this.addDrawer = false;
    },
    // 设置优惠券金额
    setCoupon(row) {
      this.couponClear();
      this.couponForm.id = row.userid;
      this.couponForm.coupon = row.balance;
      this.isCoupon = true;
    },
    // 关闭设置优惠券金额弹窗
    couponClear() {
      for (let key in this.couponForm) {
        this.couponForm[key] = "";
      }
      this.isCoupon = false;
    },
    // 优惠券金额修改提交
    couponSubmit() {
      this.$refs["couponForm"].validate((valid) => {
        if (valid) {
          let data = {
            userId: this.couponForm.id,
            balance: this.couponForm.coupon,
          };
          this.$request({
            url: "Member/UpdateUserCouponAmount",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.couponClear();
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        }
      });
    },

    /**---------------------------------- */
    /**获取优惠券数据 */
    getCoupon() {},
    /**分页数据改变 */
    hanSiChange2(val) {
      this.pageSize2 = val;
    },
    hanCurrChange2(val) {
      this.currPage2 = val;
    },
    /**优惠券 selection change触发事件 */
    selection2Change(section) {
      this.selectedList2 = section;
    },
    /**搜索优惠券 */
    searchCoupon() {},
    // 导出数据
    exportData() {
      let data = {
        type: "GetUserInfo",
        userId: window.localStorage.getItem("userId"),
        entId: window.localStorage.getItem("entId"),
        status: this.search.status,
        strWhere: this.search.name,
        salesMan: this.search.salesMan,
        telphone: this.search.telphone,
        PageIndex: 1,
        PageSize: 9999999,
      };
      let proc = "Proc_Admin_MembersQuery";
      window.location.href =
        this.baseUrl +
        "Order/NoPIGExprot?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&proc=" +
        encodeURIComponent(proc) +
        "&name=客户列表";
    },

    /************ 充值流水 **************/
    /**点击查看 */
    handleViewHistory({ row }) {
      this.selectedUser = row;
      this.topUpHisDialog = true;
      this.getUserHistory("refresh");
    },

    /**获取历史数据 */
    getUserHistory(type = "") {
      //函数太多 type: refresh search 不传参数默认加载
      if (type == "refresh") {
        this.searchForm3.start = this.$theMonthFirstDay();
        this.searchForm3.end = this.$formatDate(new Date(), false);
        this.currPage3 = 1;
      } else if (type == "search") {
        this.currPage3 = 1;
      }

      this.$request({
        method: "post",
        url: "/Management/MemberAdmin/GetUserBalanceHis",
        data: {
          sqlValue: "",
          pageIndex: this.currPage3, //分页
          pageSize: this.pageSize3,
          startDate: this.searchForm3.start, // 日期
          endDate: this.searchForm3.end,
          clientId: this.selectedUser.userid, //用户id
        },
      })
        .then((res) => {
          if (res.success) {
            this.historyList = res.list;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**分页size改变 */
    hanSiChange3(val) {
      this.pageSize3 = val;
      this.getUserHistory();
    },
    /**当前页改变 */
    hanCurrChange3(val) {
      this.currPage3 = val;
      this.getUserHistory();
    },

    /************ 充值相关 **************/
    /**点击充值 */
    handleTopUp({ row }) {
      this.selectedMem = row;
      this.topUpDialog = true;
    },

    /**提交充值 */
    submitTopMoney() {
      // 备注进行判断
      if (this.topRemark == "") {
        this.$message({
          message: "请输入备注",
          type: "warning",
        });
        return;
      }

      let data = {
        clientId: this.selectedMem.userid,
        amount: this.topUpMoney,
        remark: this.topRemark,
      };
      this.$request({
        method: "post",
        url: "/Management/MemberAdmin/UpdateUserBalance",
        data,
      })
        .then((res) => {
          let type = "";
          if (res.success) {
            type = "success";
            this.topUpDialog = false;
            this.topUpMoney = 0;
            this.topRemark = "";
            this.getTableData(this.currPage); //刷新数据
          } else {
            type = "error";
          }

          this.$message({
            message: res.message,
            type,
          });
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /************** 修改开票员和业务员 ****************/
    handleEditSaleman({ row }, searchType) {
      this.searchType = searchType;
      this.selectedItem = row;
      this.saleManDialog = true;
      this.getSalemanList("refresh");
    },

    /**获取业务员/开票员列表 */
    getSalemanList(load = "") {
      // 需要根据选择的商品范围来判断获取不同的数据
      if (load == "refresh") {
        this.pageIndex1 = 1;
        this.saleManName = "";
      } else if (load == "search") {
        this.pageIndex1 = 1;
      }

      let department = "";
      if (this.searchType == "saleMan") {
        department = "业务员";
      } else if (this.searchType == "invoice") {
        department = "开票员";
      }

      this.$request({
        method: "post",
        url: "/Management/SalesManAdmin/GetSalesManList",
        data: {
          valStr: this.saleManName,
          status: 2,
          department: department,
          pageInde: this.pageIndex1,
          pageSize: this.pageSize1,
        },
      })
        .then((res) => {
          if (res.success) {
            this.salesmenList = res.dataList || [];
            this.allPage1 = res.recordCount;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**分页size改变 */
    hanSiChange1(val) {
      this.pageSize1 = val;
      this.getSalemanList();
    },

    /**当前页改变 */
    hanCurrChange1(val) {
      this.pageIndex1 = val;
      this.getSalemanList();
    },

    /**选中某一项 */
    handleSalemanItem({ row }) {
      let data = {};
      if (this.searchType == "saleMan") {
        // 修改业务员
        data = {
          UserId: this.selectedItem.userid,
          YwyId: row.UserId,
          YwyName: row.Name,
          KpyId: this.selectedItem.KpyId,
          KpyName: this.selectedItem.KpyName,
        };
      } else if (this.searchType == "invoice") {
        // 修改开票员
        data = {
          UserId: this.selectedItem.userid,
          YwyId: this.selectedItem.YwyId,
          YwyName: this.selectedItem.YwyName,
          KpyId: row.UserId,
          KpyName: row.Name,
        };
      }

      this.$request({
        method: "post",
        url: "/Management/MemberAdmin/EditUserSalesMan",
        data,
      })
        .then(() => {
          this.saleManDialog = false;
          this.getTableData();
          // if (res.success) {
          //   this.salesmenList = res.dataList || []
          //   this.allPage1 = res.recordCount
          // } else {
          //   this.$message({
          //     message: res.message,
          //     type: "error",
          //   });
          // }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.memList {
  width: 100%;
  height: 100%;
}

/**表单提示 */
.form-item-tip {
  margin-left: 10px;
  color: #f56c6c;
  font-size: 14px;
}

/**修改业务员和开票员 */
.table-column-edit {
  color: #409eff;
  cursor: pointer;
}

.label {
  font-size: 13px;
}
.labeljs {
  font-size: 13px;
  margin-left: 10px;
}
</style>
